export default __webpack_public_path__ + "static/media/461.9a6d466d.jpg";